/* eslint-disable max-len */
import 'react';

const ErrorSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor" {...props} >
        <g id="失败" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Group-6" transform="translate(-0.900000, -1.200000)" fill="#FF6B78">
                <path d="M12.9,1.2 C19.527417,1.2 24.9,6.572583 24.9,13.2 C24.9,19.827417 19.527417,25.2 12.9,25.2 C6.272583,25.2 0.9,19.827417 0.9,13.2 C0.9,6.572583 6.272583,1.2 12.9,1.2 Z M13.2333333,17.2 L12.5666667,17.2 C12.0143819,17.2 11.5666667,17.6477153 11.5666667,18.2 L11.5666667,18.8666667 C11.5666667,19.4189514 12.0143819,19.8666667 12.5666667,19.8666667 L13.2333333,19.8666667 C13.7856181,19.8666667 14.2333333,19.4189514 14.2333333,18.8666667 L14.2333333,18.2 C14.2333333,17.6477153 13.7856181,17.2 13.2333333,17.2 Z M12.9,6.53333333 C12.1636203,6.53333333 11.5666667,7.130287 11.5666667,7.86666667 L11.5666667,14.5333333 C11.5666667,15.269713 12.1636203,15.8666667 12.9,15.8666667 C13.6363797,15.8666667 14.2333333,15.269713 14.2333333,14.5333333 L14.2333333,7.86666667 C14.2333333,7.130287 13.6363797,6.53333333 12.9,6.53333333 Z" id="形状结合"></path>
            </g>
        </g>
    </svg>
);
export default ErrorSvg;
